import React, { CSSProperties } from 'react';
import cn from 'classnames';
import { translate } from '@fiverr-private/i18n-react';
import { CertifiedBannerApi } from '../../server';
import { APP_KEY } from '../../constants';
import styles from './Logo.module.scss';

/**
 * Logo component props interface.
 */
export interface LogoProps extends Pick<CertifiedBannerApi, 'logoUrl'> {
  /**
   * Translated Fiverr Sub Category.
   */
  partnerName: string;
  /**
   * Custom `class` attribute value for Logo wrapper `div` element.
   */
  className?: string;
}

interface RootCSSProperties extends CSSProperties {
  '--url': string;
}

/**
 * Logo component with Fiverr x Partner logo image.
 */
export const Logo = ({ className, partnerName, logoUrl }: LogoProps) => (
  <div
    className={cn(styles.root, className)}
    style={{ '--url': `url(${logoUrl})` } as RootCSSProperties}
  >
    <img
      src={logoUrl}
      className={styles.partnerLogoImg}
      alt={translate(`${APP_KEY}.logo.alt`, {
        params: { partner: partnerName },
      })}
    />
  </div>
);
